import { useLayoutEffect, useRef } from 'react';

/** Only UI coordinates are stored, scoped to this tab, tenant and user. */
export function useSidebarScroll(storageKey: string, route: string, activeId: string | undefined, visible: boolean) {
  const ref = useRef<HTMLElement>(null);
  useLayoutEffect(() => {
    const nav = ref.current;
    if (!nav || !visible) return;
    let saved: { route?: string; top?: number } | undefined;
    try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null') ?? undefined; } catch { /* Storage can be unavailable. */ }
    if (saved?.route === route && Number.isFinite(saved.top)) nav.scrollTop = Math.max(0, saved.top!);
    else {
      const active = Array.from(nav.querySelectorAll<HTMLElement>('[data-menu-id]')).find(el => el.dataset.menuId === activeId);
      if (active) {
        const bounds = nav.getBoundingClientRect(), item = active.getBoundingClientRect();
        if (item.top < bounds.top) nav.scrollTop += item.top - bounds.top - 8;
        else if (item.bottom > bounds.bottom) nav.scrollTop += item.bottom - bounds.bottom + 8;
      }
    }
    const save = () => { try { sessionStorage.setItem(storageKey, JSON.stringify({ route, top: nav.scrollTop })); } catch { /* Optional preference. */ } };
    nav.addEventListener('scroll', save, { passive: true });
    window.addEventListener('pagehide', save);
    return () => { save(); nav.removeEventListener('scroll', save); window.removeEventListener('pagehide', save); };
  }, [storageKey, route, activeId, visible]);
  return ref;
}
